import { Box, Typography, Tooltip } from '@mui/material'

export default function AssignedUsersPreview({ users = [], limit = 3 }) {
  const filledUsers = [...users]
  while (filledUsers.length < limit) {
    filledUsers.push(null)
  }

  return (
    <Box
      sx={{
        flex: 1,
        overflow: 'hidden'
      }}
    >
      {filledUsers
        .slice(0, limit)
        .map((user, index) =>
          user ? (
            <UserRow key={user.id ?? index} index={index + 1} user={user} />
          ) : (
            <EmptyRow key={`empty-${index}`} />
          )
        )}
    </Box>
  )
}

function UserRow({ index, user }) {
  const fullText = `${user.uid} - ${user.name}: Ruta: ${user.route_plan_title}`

  const sx = {
    border: '1px solid #E0E0E0',
    borderRadius: 1,
    px: 1.5,
    py: 0.5,
    mb: 0.5,
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    fontSize: 13,
    lineHeight: 1.2,
    backgroundColor: '#FAFAFA',
    height: '30px',
    marginBottom: '8px'
  }

  return (
    <Box sx={sx}>
      <Typography
        sx={{
          fontWeight: 700,
          flexShrink: 0,
          color: '#606060'
        }}
      >
        {index}.
      </Typography>

      <Tooltip
        title={fullText}
        placement="top-start"
        arrow
        PopperProps={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 8]
              }
            }
          ]
        }}
      >
        <Typography
          sx={{
            flex: 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default',
            color: '#606060'
          }}
        >
          <Box component="span" sx={{ fontWeight: 700 }}>
            {`${user.uid} - ${user.name}`}
          </Box>
          {': '}
          <Box component="span" sx={{ fontStyle: 'italic' }}>
            {`Ruta: ${user.route_plan_title}`}
          </Box>
        </Typography>
      </Tooltip>
    </Box>
  )
}

function EmptyRow() {
  return (
    <Box
      sx={{
        border: '1px solid #E6E6E6',
        borderRadius: 1,
        px: 1.5,
        py: 0.5,
        mb: 0.5,
        color: '#B0B0B0',
        backgroundColor: '#FAFAFA',
        fontSize: 13
      }}
    >
      -
    </Box>
  )
}
